<script lang="ts" setup>
import type { PropType } from 'vue'
import type { TFilterItem, TFilterItemMultiselect } from '~/layers/catalog/data/types'
import {
  type TFilterStoring,
  type TFilterStoringOptions,
  TFilterStoringType,
} from '~/layers/catalog/composables/catalogFilter'
import { useCatalogFilter } from '~/layers/catalog/composables/catalogFilter'

const props = defineProps({
  filter: {
    type: Object as PropType<TFilterItemMultiselect & TFilterItem>,
    required: true,
  },
})

const isOpenedMore = ref(false)

const items = computed(() => {
  const isEnabledRuValues = useCatalogFilter().isEnabledRuValues(props.filter!.code)

  return props.filter!.items.filter((i) => (isEnabledRuValues ? i.isRuValue : !i.isRuValue))
})

const itemsToShow = computed(() => {
  const rootItems = items

  if (useMediaQuery().state.xs || useMediaQuery().state.sm || useMediaQuery().state.md) {
    return rootItems.value
  }

  if (isOpenedMore.value) {
    return rootItems.value
  }

  return rootItems.value.slice(0, 10)
})

const toggle = () => {
  isOpenedMore.value = !isOpenedMore.value
}

const service = useCatalogFilter()

const checkedOptions = computed(() => {
  const storing = service.get(props.filter?.code) as (TFilterStoring & TFilterStoringOptions) | null
  return storing?.options || []
})

const toggleOption = (option: string) => {
  const options = checkedOptions.value.includes(option)
    ? checkedOptions.value.filter((o) => o !== option)
    : [...checkedOptions.value, option]
  if (!options.length) {
    service.remove(props.filter.code)
    return
  }
  service.set(props.filter.code, { options, type: TFilterStoringType.Options })
}
</script>

<template>
  <div :class="filter.code === 'size' && 'filters__value-col'">
    <client-only>
      <div v-for="option in itemsToShow" :key="option.name" class="filters__value" :class="option.disabled && checkedOptions.includes(option.code) && 'disabledAndChecked'">
        <label>
          <input
            :disabled="!checkedOptions.includes(option.code) && option.disabled"
            class="filters__value-input"
            type="checkbox"
            :checked="checkedOptions.includes(option.code)"
            @change="toggleOption(option.code)"
          />
          <p class="filters__value-text">{{ option.name }}</p>
        </label>
      </div>
    </client-only>
  </div>

  <client-only>
    <button v-if="items.length > 10" class="filters__button-show text-left" @click="toggle">
      <span v-if="!isOpenedMore" class="filters__button-show_more">Ещё {{ filter.title.toLowerCase() }}</span>
      <span v-else class="filters__button-show_hide">Свернуть</span>
    </button>
  </client-only>
</template>
